export default function checkPlainObject(obj: any): boolean {
  return obj != null && obj.constructor.name === 'Object';
}
